import LocationForm from "./LocationForm";
import { KListTile, KSelect } from "kinnect-general";
import { Location } from "kinnect-models";
import { VDialog, VIcon } from "vuetify/lib";
import { sortByKey } from "kinnect-helpers";

export default {
	name: "LocationField",

	extends: KSelect,

	props: {
		itemText: {
			default: "name",
			type: String
		},
		itemValue: {
			default: "id",
			type: String
		},
		prependIcon: {
			default: "store",
			type: String
		},
		showAddButton: Boolean
	},

	data: () => ( {
		dialogOpen: false
	} ),

	computed: {
		sortedItems() {
			return sortByKey( this.items, this.itemText );
		}
	},

	methods: {
		createItem( { data } ) {
			this.$emit( "create", new Location( data ) );
		}
	},

	render() {
		return <KSelect
			attrs={{
				...this.$props,
				items: this.sortedItems
			}}
			on={{ ...this.$listeners }}
			scopedSlots={{ ...this.$scopedSlots }}
		>
			{this.showAddButton && <VDialog
				class="white"
				persistent
				scopedSlots={{ activator: ( { on } ) => <VIcon on={on}>add_circle</VIcon> }}
				slot="append-outer"
				vModel={this.dialogOpen}
				width="500"
			>
				{this.dialogOpen && <LocationForm
					formTitle={"Add a Location"}
					onClose={() => this.dialogOpen = false}
					onSuccess={this.createItem}
				></LocationForm>}
			</VDialog>}

			<KListTile text="No locations to display" slot="no-data"></KListTile>
		</KSelect>;
	}
};
